module.exports = {
      id: "protocol-usage",
      viewBox: "0 0 34 32",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#protocol-usage",
      toString: function () {
        return this.url;
      }
    }